// extracted by mini-css-extract-plugin
module.exports = {"weeklyBalance":"AccountOverview_weeklyBalance__12sPY","label":"AccountOverview_label__2RUhl","balance":"AccountOverview_balance__2n9kJ"};